/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
import * as i0 from '@angular/core';
import * as i1 from '@angular/forms';
import * as i2 from '@angular/common';
import * as i3 from '../../common/wizard/wizard-step.component.ngfactory';
import * as i4 from '../../../../../src/app/common/wizard/wizard-step.component';
import * as i5 from './datos-ingreso.component.ngfactory';
import * as i6 from '../../../../../src/app/components/ingresocausa/datos-ingreso.component';
import * as i7 from '../../../../../src/app/services/usuario.service';
import * as i8 from '../../../../../src/app/services/expediente.service';
import * as i9 from '../../../../../src/app/services/common.service';
import * as i10 from '../../common/wizard/wizard.component.ngfactory';
import * as i11 from '../../../../../src/app/common/wizard/wizard.component';
import * as i12 from './datos-demanda.component.ngfactory';
import * as i13 from '../../../../../src/app/components/ingresocausa/datos-demanda.component';
import * as i14 from './partes-causa.component.ngfactory';
import * as i15 from '../../../../../src/app/components/ingresocausa/partes-causa.component';
import * as i16 from './demanda.component.ngfactory';
import * as i17 from '../../../../../src/app/components/ingresocausa/demanda.component';
import * as i18 from './ficha.component.ngfactory';
import * as i19 from '../../../../../src/app/components/ingresocausa/ficha.component';
import * as i20 from './firmar.component.ngfactory';
import * as i21 from '../../../../../src/app/components/ingresocausa/firmar.component';
import * as i22 from '@angular/platform-browser';
import * as i23 from '../../common/dialog/mensaje.component.ngfactory';
import * as i24 from '../../../../../src/app/common/dialog/mensaje.component';
import * as i25 from '../../../../../src/app/components/ingresocausa/nueva-causa.component';
var styles_NuevaCausaComponent = [];
export var RenderType_NuevaCausaComponent = i0.ɵcrt({ encapsulation: 2,
    styles: styles_NuevaCausaComponent, data: {} });
function View_NuevaCausaComponent_2(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 3, 'option', [], null, null, null, null, null)), i0.ɵdid(147456, null, 0, i1.NgSelectOption, [i0.ElementRef, i0.Renderer2, [2, i1.SelectControlValueAccessor]], { value: [0, 'value'] }, null), i0.ɵdid(147456, null, 0, i1.ɵq, [i0.ElementRef,
            i0.Renderer2, [8, null]], { value: [0, 'value'] }, null), (_l()(), i0.ɵted(null, ['', '']))], function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.id;
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.id;
        _ck(_v, 2, 0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit.descr;
        _ck(_v, 3, 0, currVal_2);
    });
}
function View_NuevaCausaComponent_4(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 3, 'option', [], null, null, null, null, null)), i0.ɵdid(147456, null, 0, i1.NgSelectOption, [i0.ElementRef, i0.Renderer2, [2, i1.SelectControlValueAccessor]], { value: [0, 'value'] }, null), i0.ɵdid(147456, null, 0, i1.ɵq, [i0.ElementRef,
            i0.Renderer2, [8, null]], { value: [0, 'value'] }, null), (_l()(), i0.ɵted(null, ['', '']))], function (_ck, _v) {
        var currVal_0 = _v.context.$implicit;
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = _v.context.$implicit;
        _ck(_v, 2, 0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit;
        _ck(_v, 3, 0, currVal_2);
    });
}
function View_NuevaCausaComponent_3(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 66, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 63, 'div', [['class', 'col-xs-12 col-xs-offset-0 col-sm-8 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-8 bottom-input-m']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class', 'col-xs-12 col-sm-2']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 1, 'label', [['class', 'reset-margin']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Expediente'])),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 20, 'div', [['class', 'col-xs-12 col-sm-2 ']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])),
        (_l()(), i0.ɵeld(0, null, null, 17, 'div', [['class', 'form-group fg-line']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 14, 'select', [['class', 'form-control reset-margin bginputs']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (i0.ɵnov(_v, 15).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 15).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_2 = ((_co.tex_cod_conexo = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (('change' === en)) {
                var pd_3 = (_co.onChangeSelectTipoExpConexo($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.SelectControlValueAccessor, [i0.Renderer2, i0.ElementRef], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.SelectControlValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null], [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { model: [0, 'model'] }, { update: 'ngModelChange' }), i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null), (_l()(), i0.ɵted(null, [' \n                            '])), (_l()(), i0.ɵeld(0, null, null, 3, 'option', [['value', '']], null, null, null, null, null)), i0.ɵdid(147456, null, 0, i1.NgSelectOption, [i0.ElementRef,
            i0.Renderer2, [2, i1.SelectControlValueAccessor]], { value: [0, 'value'] }, null),
        i0.ɵdid(147456, null, 0, i1.ɵq, [i0.ElementRef, i0.Renderer2, [8, null]], { value: [0, 'value'] }, null), (_l()(), i0.ɵted(null, ['Seleccionar...'])),
        (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_NuevaCausaComponent_4)),
        i0.ɵdid(802816, null, 0, i2.NgForOf, [i0.ViewContainerRef, i0.TemplateRef,
            i0.IterableDiffers], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵted(null, ['\n                    '])),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 12, 'div', [['class', 'col-xs-12 col-sm-4']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])),
        (_l()(), i0.ɵeld(0, null, null, 9, 'div', [['class', 'form-group fg-line']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 6, 'input', [['class', 'form-control input-sm reset-margin'],
            ['placeholder', 'Número'], ['type', 'number']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'focus'], [null,
                'ngModelChange'], [null, 'input'], [null, 'blur'], [null,
                'compositionstart'], [null, 'compositionend'], [null,
                'change']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (i0.ɵnov(_v, 37)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 37).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (i0.ɵnov(_v, 37)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (i0.ɵnov(_v, 37)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('change' === en)) {
                var pd_4 = (i0.ɵnov(_v, 38).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (('input' === en)) {
                var pd_5 = (i0.ɵnov(_v, 38).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (('blur' === en)) {
                var pd_6 = (i0.ɵnov(_v, 38).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (('focus' === en)) {
                var pd_7 = (_co.hideErrorMsgConexo() !== false);
                ad = (pd_7 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_8 = ((_co.nro = $event) !== false);
                ad = (pd_8 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.DefaultValueAccessor, [i0.Renderer2, i0.ElementRef, [2, i1.COMPOSITION_BUFFER_MODE]], null, null), i0.ɵdid(16384, null, 0, i1.ɵbc, [i0.Renderer2, i0.ElementRef], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [i1.DefaultValueAccessor, i1.ɵbc]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null], [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { model: [0, 'model'] }, { update: 'ngModelChange' }), i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵted(null, ['\n                '])),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 12, 'div', [['class', 'col-xs-12 col-sm-2']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 9, 'div', [['class', 'form-group fg-line']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 6, 'input', [['class', 'form-control input-sm reset-margin'],
            ['placeholder', 'Año'], ['type', 'number']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'focus'], [null,
                'ngModelChange'], [null, 'input'], [null, 'blur'], [null,
                'compositionstart'], [null, 'compositionend'], [null, 'change']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (i0.ɵnov(_v, 51)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 51).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (i0.ɵnov(_v, 51)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (i0.ɵnov(_v, 51)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('change' === en)) {
                var pd_4 = (i0.ɵnov(_v, 52).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (('input' === en)) {
                var pd_5 = (i0.ɵnov(_v, 52).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (('blur' === en)) {
                var pd_6 = (i0.ɵnov(_v, 52).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (('focus' === en)) {
                var pd_7 = (_co.hideErrorMsgConexo() !== false);
                ad = (pd_7 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_8 = ((_co.anio = $event) !== false);
                ad = (pd_8 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.DefaultValueAccessor, [i0.Renderer2, i0.ElementRef, [2, i1.COMPOSITION_BUFFER_MODE]], null, null), i0.ɵdid(16384, null, 0, i1.ɵbc, [i0.Renderer2, i0.ElementRef], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [i1.DefaultValueAccessor, i1.ɵbc]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null], [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { model: [0, 'model'] }, { update: 'ngModelChange' }), i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵted(null, ['\n                '])),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class', 'col-sm-2']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 1, 'button', [['class', 'btn btn-primary btn-verMas btn-buscar ajuste-margen-top']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onClickBuscarConexo() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['Buscar'])),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵted(null, ['\n        ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _co.tex_cod_conexo;
        _ck(_v, 17, 0, currVal_7);
        var currVal_8 = '';
        _ck(_v, 22, 0, currVal_8);
        var currVal_9 = '';
        _ck(_v, 23, 0, currVal_9);
        var currVal_10 = _co.texListConexo;
        _ck(_v, 27, 0, currVal_10);
        var currVal_18 = _co.nro;
        _ck(_v, 40, 0, currVal_18);
        var currVal_26 = _co.anio;
        _ck(_v, 54, 0, currVal_26);
    }, function (_ck, _v) {
        var currVal_0 = i0.ɵnov(_v, 19).ngClassUntouched;
        var currVal_1 = i0.ɵnov(_v, 19).ngClassTouched;
        var currVal_2 = i0.ɵnov(_v, 19).ngClassPristine;
        var currVal_3 = i0.ɵnov(_v, 19).ngClassDirty;
        var currVal_4 = i0.ɵnov(_v, 19).ngClassValid;
        var currVal_5 = i0.ɵnov(_v, 19).ngClassInvalid;
        var currVal_6 = i0.ɵnov(_v, 19).ngClassPending;
        _ck(_v, 14, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_11 = i0.ɵnov(_v, 42).ngClassUntouched;
        var currVal_12 = i0.ɵnov(_v, 42).ngClassTouched;
        var currVal_13 = i0.ɵnov(_v, 42).ngClassPristine;
        var currVal_14 = i0.ɵnov(_v, 42).ngClassDirty;
        var currVal_15 = i0.ɵnov(_v, 42).ngClassValid;
        var currVal_16 = i0.ɵnov(_v, 42).ngClassInvalid;
        var currVal_17 = i0.ɵnov(_v, 42).ngClassPending;
        _ck(_v, 36, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17);
        var currVal_19 = i0.ɵnov(_v, 56).ngClassUntouched;
        var currVal_20 = i0.ɵnov(_v, 56).ngClassTouched;
        var currVal_21 = i0.ɵnov(_v, 56).ngClassPristine;
        var currVal_22 = i0.ɵnov(_v, 56).ngClassDirty;
        var currVal_23 = i0.ɵnov(_v, 56).ngClassValid;
        var currVal_24 = i0.ɵnov(_v, 56).ngClassInvalid;
        var currVal_25 = i0.ɵnov(_v, 56).ngClassPending;
        _ck(_v, 50, 0, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25);
    });
}
function View_NuevaCausaComponent_5(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 6, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 3, 'div', [['class', 'col-xs-12 col-sm-12 text-center isa_error msg-error']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 0, 'i', [['class', 'fa fa-times-circle']], null, null, null, null, null)), (_l()(), i0.ɵted(null, [' ', '\n            '])), (_l()(), i0.ɵted(null, ['\n        ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.ErrorMsgB;
        _ck(_v, 5, 0, currVal_0);
    });
}
function View_NuevaCausaComponent_6(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 20, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 17, 'div', [['class', 'col-xs-12 col-xs-offset-0 col-sm-8 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-8 bottom-input-m']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 14, 'div', [['class', 'fg-line']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 11, 'div', [['class', 'select']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Caratula '])), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, [['input', 1]], null, 5, 'input', [['class', 'form-control input-sm bginputs t-upper'],
            ['disabled', ''], ['placeholder', ''], ['type', 'text']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'input'], [null,
                'blur'], [null, 'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (i0.ɵnov(_v, 12)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 12).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (i0.ɵnov(_v, 12)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (i0.ɵnov(_v, 12)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('input' === en)) {
                var pd_4 = ((i0.ɵnov(_v, 11).value = $event.target.value.toUpperCase()) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.DefaultValueAccessor, [i0.Renderer2, i0.ElementRef, [2, i1.COMPOSITION_BUFFER_MODE]], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.DefaultValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null],
            [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { isDisabled: [0,
                'isDisabled'], model: [1, 'model'] }, null), i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵted(null, ['\n                '])),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵted(null, ['\n         ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = '';
        var currVal_8 = ((_co.expConexo == null) ? null : _co.expConexo.caratula);
        _ck(_v, 14, 0, currVal_7, currVal_8);
    }, function (_ck, _v) {
        var currVal_0 = i0.ɵnov(_v, 16).ngClassUntouched;
        var currVal_1 = i0.ɵnov(_v, 16).ngClassTouched;
        var currVal_2 = i0.ɵnov(_v, 16).ngClassPristine;
        var currVal_3 = i0.ɵnov(_v, 16).ngClassDirty;
        var currVal_4 = i0.ɵnov(_v, 16).ngClassValid;
        var currVal_5 = i0.ɵnov(_v, 16).ngClassInvalid;
        var currVal_6 = i0.ɵnov(_v, 16).ngClassPending;
        _ck(_v, 11, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_NuevaCausaComponent_7(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 20, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 17, 'div', [['class', 'col-xs-12 col-xs-offset-0 col-sm-8 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-8 bottom-input-m']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 14, 'div', [['class', 'fg-line']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 11, 'div', [['class', 'select']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Concepto '])), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, [['input', 1]], null, 5, 'input', [['class', 'form-control input-sm bginputs t-upper'],
            ['disabled', ''], ['placeholder', ''], ['type', 'text']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'input'], [null,
                'blur'], [null, 'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (i0.ɵnov(_v, 12)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 12).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (i0.ɵnov(_v, 12)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (i0.ɵnov(_v, 12)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('input' === en)) {
                var pd_4 = ((i0.ɵnov(_v, 11).value = $event.target.value.toUpperCase()) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.DefaultValueAccessor, [i0.Renderer2, i0.ElementRef, [2, i1.COMPOSITION_BUFFER_MODE]], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.DefaultValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null],
            [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { isDisabled: [0,
                'isDisabled'], model: [1, 'model'] }, null), i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵted(null, ['\n                '])),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵted(null, ['\n         ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = '';
        var currVal_8 = ((_co.expConexo == null) ? null : _co.expConexo.materia);
        _ck(_v, 14, 0, currVal_7, currVal_8);
    }, function (_ck, _v) {
        var currVal_0 = i0.ɵnov(_v, 16).ngClassUntouched;
        var currVal_1 = i0.ɵnov(_v, 16).ngClassTouched;
        var currVal_2 = i0.ɵnov(_v, 16).ngClassPristine;
        var currVal_3 = i0.ɵnov(_v, 16).ngClassDirty;
        var currVal_4 = i0.ɵnov(_v, 16).ngClassValid;
        var currVal_5 = i0.ɵnov(_v, 16).ngClassInvalid;
        var currVal_6 = i0.ɵnov(_v, 16).ngClassPending;
        _ck(_v, 11, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_NuevaCausaComponent_8(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 3, 'option', [], null, null, null, null, null)), i0.ɵdid(147456, null, 0, i1.NgSelectOption, [i0.ElementRef, i0.Renderer2, [2, i1.SelectControlValueAccessor]], { value: [0, 'value'] }, null), i0.ɵdid(147456, null, 0, i1.ɵq, [i0.ElementRef,
            i0.Renderer2, [8, null]], { value: [0, 'value'] }, null), (_l()(), i0.ɵted(null, ['', '']))], function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.id;
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.id;
        _ck(_v, 2, 0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit.descr;
        _ck(_v, 3, 0, currVal_2);
    });
}
function View_NuevaCausaComponent_9(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 3, 'option', [], null, null, null, null, null)), i0.ɵdid(147456, null, 0, i1.NgSelectOption, [i0.ElementRef, i0.Renderer2, [2, i1.SelectControlValueAccessor]], { value: [0, 'value'] }, null), i0.ɵdid(147456, null, 0, i1.ɵq, [i0.ElementRef,
            i0.Renderer2, [8, null]], { value: [0, 'value'] }, null), (_l()(), i0.ɵted(null, ['', '']))], function (_ck, _v) {
        var currVal_0 = _v.context.$implicit;
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = _v.context.$implicit;
        _ck(_v, 2, 0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit;
        _ck(_v, 3, 0, currVal_2);
    });
}
function View_NuevaCausaComponent_10(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 3, 'option', [], null, null, null, null, null)), i0.ɵdid(147456, null, 0, i1.NgSelectOption, [i0.ElementRef, i0.Renderer2, [2, i1.SelectControlValueAccessor]], { value: [0, 'value'] }, null), i0.ɵdid(147456, null, 0, i1.ɵq, [i0.ElementRef,
            i0.Renderer2, [8, null]], { value: [0, 'value'] }, null), (_l()(), i0.ɵted(null, ['', '']))], function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.id;
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.id;
        _ck(_v, 2, 0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit.descr;
        _ck(_v, 3, 0, currVal_2);
    });
}
function View_NuevaCausaComponent_11(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 20, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 17, 'div', [['class', 'col-xs-12 col-xs-offset-0 col-sm-8 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-8 bottom-input-m']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 14, 'div', [['class', 'fg-line']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 11, 'div', [['class', 'select']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Organismo '])), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, [['input', 1]], null, 5, 'input', [['class', 'form-control input-sm bginputs t-upper'],
            ['disabled', ''], ['placeholder', ''], ['type', 'text']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'input'], [null,
                'blur'], [null, 'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (i0.ɵnov(_v, 12)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 12).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (i0.ɵnov(_v, 12)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (i0.ɵnov(_v, 12)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('input' === en)) {
                var pd_4 = ((i0.ɵnov(_v, 11).value = $event.target.value.toUpperCase()) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.DefaultValueAccessor, [i0.Renderer2, i0.ElementRef, [2, i1.COMPOSITION_BUFFER_MODE]], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.DefaultValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null],
            [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { isDisabled: [0,
                'isDisabled'], model: [1, 'model'] }, null), i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵted(null, ['\n                '])),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵted(null, ['\n         ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = '';
        var currVal_8 = ((_co.expConexo == null) ? null : _co.expConexo.organismo);
        _ck(_v, 14, 0, currVal_7, currVal_8);
    }, function (_ck, _v) {
        var currVal_0 = i0.ɵnov(_v, 16).ngClassUntouched;
        var currVal_1 = i0.ɵnov(_v, 16).ngClassTouched;
        var currVal_2 = i0.ɵnov(_v, 16).ngClassPristine;
        var currVal_3 = i0.ɵnov(_v, 16).ngClassDirty;
        var currVal_4 = i0.ɵnov(_v, 16).ngClassValid;
        var currVal_5 = i0.ɵnov(_v, 16).ngClassInvalid;
        var currVal_6 = i0.ɵnov(_v, 16).ngClassPending;
        _ck(_v, 11, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_NuevaCausaComponent_12(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 20, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 17, 'div', [['class', 'col-xs-12 col-xs-offset-0 col-sm-8 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-8 bottom-input-m']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 14, 'div', [['class', 'fg-line']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 11, 'div', [['class', 'select']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Secretaria '])), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, [['input', 1]], null, 5, 'input', [['class', 'form-control input-sm bginputs t-upper'],
            ['disabled', ''], ['placeholder', ''], ['type', 'text']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'input'], [null,
                'blur'], [null, 'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (i0.ɵnov(_v, 12)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 12).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (i0.ɵnov(_v, 12)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (i0.ɵnov(_v, 12)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('input' === en)) {
                var pd_4 = ((i0.ɵnov(_v, 11).value = $event.target.value.toUpperCase()) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.DefaultValueAccessor, [i0.Renderer2, i0.ElementRef, [2, i1.COMPOSITION_BUFFER_MODE]], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.DefaultValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null],
            [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { isDisabled: [0,
                'isDisabled'], model: [1, 'model'] }, null), i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵted(null, ['\n                '])),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵted(null, ['\n         ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = '';
        var currVal_8 = ((_co.secretaria == null) ? null : _co.secretaria.descripcion);
        _ck(_v, 14, 0, currVal_7, currVal_8);
    }, function (_ck, _v) {
        var currVal_0 = i0.ɵnov(_v, 16).ngClassUntouched;
        var currVal_1 = i0.ɵnov(_v, 16).ngClassTouched;
        var currVal_2 = i0.ɵnov(_v, 16).ngClassPristine;
        var currVal_3 = i0.ɵnov(_v, 16).ngClassDirty;
        var currVal_4 = i0.ɵnov(_v, 16).ngClassValid;
        var currVal_5 = i0.ɵnov(_v, 16).ngClassInvalid;
        var currVal_6 = i0.ɵnov(_v, 16).ngClassPending;
        _ck(_v, 11, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_NuevaCausaComponent_13(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 3, 'option', [], null, null, null, null, null)), i0.ɵdid(147456, null, 0, i1.NgSelectOption, [i0.ElementRef, i0.Renderer2, [8, null]], { value: [0, 'value'] }, null), i0.ɵdid(147456, null, 0, i1.ɵq, [i0.ElementRef,
            i0.Renderer2, [8, null]], { value: [0, 'value'] }, null), (_l()(), i0.ɵted(null, ['', '']))], function (_ck, _v) {
        var currVal_0 = _v.context.$implicit;
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = _v.context.$implicit;
        _ck(_v, 2, 0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit;
        _ck(_v, 3, 0, currVal_2);
    });
}
function View_NuevaCausaComponent_14(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 6, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 3, 'div', [['class', 'col-xs-12 col-sm-8  isa_success']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 0, 'i', [['class', 'fa fa-check']], null, null, null, null, null)), (_l()(), i0.ɵted(null, [' ', '\n            '])),
        (_l()(), i0.ɵted(null, ['\n        ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.SuccessMsg;
        _ck(_v, 5, 0, currVal_0);
    });
}
function View_NuevaCausaComponent_1(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 216, 'div', [['class',
                'row card card-causa-masivo']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 7, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])),
        (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class', 'col-xs-12 col-xs-offset-0 col-sm-8 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-8']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 1, 'h4', [['class', 'altura-title']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Tipo de Expediente a Generar'])), (_l()(), i0.ɵted(null, ['\n            '])),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n\n\n        '])), (_l()(), i0.ɵeld(0, null, null, 18, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(),
            i0.ɵeld(0, null, null, 15, 'div', [['class', 'col-xs-12 col-xs-offset-0 col-sm-8 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-8 bottom-input-m']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 11, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])),
        (_l()(), i0.ɵeld(0, null, null, 8, 'div', [['class', 'col-xs-7 col-sm-6']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 1, 'label', [['class', 'ts-label reset-margin']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['INGRESO'])), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 2, 'label', [['class', 'ts-label reset-margin']], null, null, null, null, null)),
        (_l()(), i0.ɵeld(0, null, null, 1, 'strong', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(),
            i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n            '])),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n\n        '])), (_l()(), i0.ɵeld(0, null, null, 30, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(),
            i0.ɵeld(0, null, null, 27, 'div', [['class', 'col-xs-12 col-xs-offset-0 col-sm-8 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-8 bottom-input-m']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 24, 'div', [['class', 'fg-line']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class', 'col-xs-12 col-sm-3']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Tipo de Ingreso'])), (_l()(), i0.ɵted(null, ['\n                    '])),
        (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 15, 'div', [['class', 'col-xs-12 col-sm-6']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵeld(0, null, null, 12, 'div', [['class', 'select']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                '])),
        (_l()(), i0.ɵeld(0, null, null, 9, 'select', [['class', 'form-control bginputs']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'focus'], [null, 'change'], [null, 'ngModelChange'], [null,
                'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (i0.ɵnov(_v, 48).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 48).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('focus' === en)) {
                var pd_2 = (_co.hideErrorMsg() !== false);
                ad = (pd_2 && ad);
            }
            if (('change' === en)) {
                var pd_3 = (_co.onChangeSelectTiposIngreso($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.tipoIng = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.SelectControlValueAccessor, [i0.Renderer2, i0.ElementRef], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.SelectControlValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null], [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { model: [0, 'model'] }, { update: 'ngModelChange' }), i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null), (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_NuevaCausaComponent_2)), i0.ɵdid(802816, null, 0, i2.NgForOf, [i0.ViewContainerRef, i0.TemplateRef, i0.IterableDiffers], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), i0.ɵted(null, ['\n                                '])),
        (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵted(null, ['            \n                '])),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n\n        '])), (_l()(),
            i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_NuevaCausaComponent_3)), i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n\n\n        '])), (_l()(),
            i0.ɵand(16777216, null, null, 1, null, View_NuevaCausaComponent_5)),
        i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n\n        '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_NuevaCausaComponent_6)),
        i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(),
            i0.ɵand(16777216, null, null, 1, null, View_NuevaCausaComponent_7)),
        i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(),
            i0.ɵted(null, ['\n\n        '])), (_l()(), i0.ɵeld(0, null, null, 30, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])),
        (_l()(), i0.ɵeld(0, null, null, 27, 'div', [['class', 'col-xs-12 col-xs-offset-0 col-sm-8 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-8 bottom-input-m']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 24, 'div', [['class', 'fg-line']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 21, 'div', [['class', 'select required']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Circunscripción '])), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 15, 'select', [['class', 'form-control bginputs']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'focus'], [null, 'change'], [null, 'ngModelChange'], [null,
                'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (i0.ɵnov(_v, 89).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 89).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('focus' === en)) {
                var pd_2 = (_co.hideErrorMsg() !== false);
                ad = (pd_2 && ad);
            }
            if (('change' === en)) {
                var pd_3 = (_co.onChangeSelectCir($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.cir = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.SelectControlValueAccessor, [i0.Renderer2, i0.ElementRef], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.SelectControlValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null], [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { isDisabled: [0, 'isDisabled'], model: [1, 'model'] }, { update: 'ngModelChange' }),
        i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null),
        (_l()(), i0.ɵted(null, [' '])), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵeld(0, null, null, 3, 'option', [['value', '0']], null, null, null, null, null)), i0.ɵdid(147456, null, 0, i1.NgSelectOption, [i0.ElementRef, i0.Renderer2, [2, i1.SelectControlValueAccessor]], { value: [0, 'value'] }, null), i0.ɵdid(147456, null, 0, i1.ɵq, [i0.ElementRef, i0.Renderer2, [8, null]], { value: [0, 'value'] }, null),
        (_l()(), i0.ɵted(null, ['Seleccionar...'])), (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_NuevaCausaComponent_8)), i0.ɵdid(802816, null, 0, i2.NgForOf, [i0.ViewContainerRef, i0.TemplateRef, i0.IterableDiffers], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n            '])),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 29, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(),
            i0.ɵeld(0, null, null, 26, 'div', [['class', 'col-xs-12 col-xs-offset-0 col-sm-8 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-8 bottom-input-m']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 23, 'div', [['class', 'fg-line']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 20, 'div', [['class', 'select required']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Instancia '])), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 14, 'select', [['class', 'form-control bginputs']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'focus'], [null, 'change'], [null, 'ngModelChange'], [null,
                'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (i0.ɵnov(_v, 121).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 121).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('focus' === en)) {
                var pd_2 = (_co.hideErrorMsg() !== false);
                ad = (pd_2 && ad);
            }
            if (('change' === en)) {
                var pd_3 = (_co.onChangeSelectInst($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.instancia = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.SelectControlValueAccessor, [i0.Renderer2, i0.ElementRef], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.SelectControlValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null], [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { isDisabled: [0, 'isDisabled'], model: [1, 'model'] }, { update: 'ngModelChange' }),
        i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null),
        (_l()(), i0.ɵted(null, [' \n                            '])), (_l()(),
            i0.ɵeld(0, null, null, 3, 'option', [['value', '0']], null, null, null, null, null)), i0.ɵdid(147456, null, 0, i1.NgSelectOption, [i0.ElementRef, i0.Renderer2, [2, i1.SelectControlValueAccessor]], { value: [0, 'value'] }, null), i0.ɵdid(147456, null, 0, i1.ɵq, [i0.ElementRef, i0.Renderer2, [8, null]], { value: [0, 'value'] }, null),
        (_l()(), i0.ɵted(null, ['Seleccionar...'])), (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_NuevaCausaComponent_9)), i0.ɵdid(802816, null, 0, i2.NgForOf, [i0.ViewContainerRef, i0.TemplateRef, i0.IterableDiffers], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n            '])),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n\n        '])), (_l()(), i0.ɵeld(0, null, null, 29, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(),
            i0.ɵeld(0, null, null, 26, 'div', [['class', 'col-xs-12 col-xs-offset-0 col-sm-8 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-8 bottom-input-m']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 23, 'div', [['class', 'fg-line']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 20, 'div', [['class', 'select required']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Fuero '])), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 14, 'select', [['class', 'form-control bginputs']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'focus'], [null, 'change'], [null, 'ngModelChange'], [null,
                'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (i0.ɵnov(_v, 152).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 152).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('focus' === en)) {
                var pd_2 = (_co.hideErrorMsg() !== false);
                ad = (pd_2 && ad);
            }
            if (('change' === en)) {
                var pd_3 = (_co.onChangeSelectFue($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.fue = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.SelectControlValueAccessor, [i0.Renderer2, i0.ElementRef], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.SelectControlValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null], [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { isDisabled: [0, 'isDisabled'], model: [1, 'model'] }, { update: 'ngModelChange' }),
        i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null),
        (_l()(), i0.ɵted(null, [' \n                            '])), (_l()(),
            i0.ɵeld(0, null, null, 3, 'option', [['value', '0']], null, null, null, null, null)), i0.ɵdid(147456, null, 0, i1.NgSelectOption, [i0.ElementRef, i0.Renderer2, [2, i1.SelectControlValueAccessor]], { value: [0, 'value'] }, null), i0.ɵdid(147456, null, 0, i1.ɵq, [i0.ElementRef, i0.Renderer2, [8, null]], { value: [0, 'value'] }, null),
        (_l()(), i0.ɵted(null, ['Seleccionar...'])), (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_NuevaCausaComponent_10)), i0.ɵdid(802816, null, 0, i2.NgForOf, [i0.ViewContainerRef, i0.TemplateRef, i0.IterableDiffers], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n            '])),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n\n        '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_NuevaCausaComponent_11)), i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), i0.ɵted(null, ['\n        \n        '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_NuevaCausaComponent_12)),
        i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n\n        '])),
        (_l()(), i0.ɵeld(0, null, null, 25, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 22, 'div', [['class', 'col-xs-12 col-xs-offset-0 col-sm-8 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-8 bottom-input-m']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 19, 'div', [['class', 'fg-line']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 16, 'div', [['class', 'select required']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Tipo de Expediente '])), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 10, 'select', [['class', 'form-control bginputs']], null, [[null, 'focus'], [null, 'change']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('focus' === en)) {
                var pd_0 = (_co.hideErrorMsg() !== false);
                ad = (pd_0 && ad);
            }
            if (('change' === en)) {
                var pd_1 = (_co.onChangeSelectTipo($event.target.value) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, [' '])), (_l()(),
            i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵeld(0, null, null, 3, 'option', [['value', '']], null, null, null, null, null)), i0.ɵdid(147456, null, 0, i1.NgSelectOption, [i0.ElementRef, i0.Renderer2, [8, null]], { value: [0,
                'value'] }, null), i0.ɵdid(147456, null, 0, i1.ɵq, [i0.ElementRef,
            i0.Renderer2, [8, null]], { value: [0, 'value'] }, null), (_l()(),
            i0.ɵted(null, ['Seleccionar...'])), (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_NuevaCausaComponent_13)), i0.ɵdid(802816, null, 0, i2.NgForOf, [i0.ViewContainerRef, i0.TemplateRef, i0.IterableDiffers], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n            '])),
        (_l()(), i0.ɵted(null, ['\n         '])), (_l()(), i0.ɵted(null, ['\n         \n        '])), (_l()(), i0.ɵted(null, ['\n        '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_NuevaCausaComponent_14)),
        i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(),
            i0.ɵeld(0, null, null, 7, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class', 'col-xs-12 col-xs-offset-0 col-sm-4 col-sm-offset-3 col-md-4 col-md-offset-4 col-lg-4 col-lg-offset-4 bottom-input-m']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 1, 'button', [['class', 'btn btn-primary btn-verMas btn-buscar']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onClickIniciar() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['Iniciar'])),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n    ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_8 = _co.tipoIng;
        _ck(_v, 50, 0, currVal_8);
        var currVal_9 = _co.tiposIngresoList;
        _ck(_v, 55, 0, currVal_9);
        var currVal_10 = _co.ingConexo;
        _ck(_v, 65, 0, currVal_10);
        var currVal_11 = _co.ErrorMessageIsVisibleB;
        _ck(_v, 68, 0, currVal_11);
        var currVal_12 = _co.ingConexo;
        _ck(_v, 71, 0, currVal_12);
        var currVal_13 = _co.ingConexo;
        _ck(_v, 74, 0, currVal_13);
        var currVal_21 = _co.ingConexo;
        var currVal_22 = _co.cir;
        _ck(_v, 91, 0, currVal_21, currVal_22);
        var currVal_23 = '0';
        _ck(_v, 97, 0, currVal_23);
        var currVal_24 = '0';
        _ck(_v, 98, 0, currVal_24);
        var currVal_25 = _co.cirList;
        _ck(_v, 102, 0, currVal_25);
        var currVal_33 = _co.ingConexo;
        var currVal_34 = _co.instancia;
        _ck(_v, 123, 0, currVal_33, currVal_34);
        var currVal_35 = '0';
        _ck(_v, 128, 0, currVal_35);
        var currVal_36 = '0';
        _ck(_v, 129, 0, currVal_36);
        var currVal_37 = _co.instList;
        _ck(_v, 133, 0, currVal_37);
        var currVal_45 = _co.ingConexo;
        var currVal_46 = _co.fue;
        _ck(_v, 154, 0, currVal_45, currVal_46);
        var currVal_47 = '0';
        _ck(_v, 159, 0, currVal_47);
        var currVal_48 = '0';
        _ck(_v, 160, 0, currVal_48);
        var currVal_49 = _co.fueList;
        _ck(_v, 164, 0, currVal_49);
        var currVal_50 = _co.ingConexo;
        _ck(_v, 172, 0, currVal_50);
        var currVal_51 = _co.ingConexo;
        _ck(_v, 175, 0, currVal_51);
        var currVal_52 = '';
        _ck(_v, 192, 0, currVal_52);
        var currVal_53 = '';
        _ck(_v, 193, 0, currVal_53);
        var currVal_54 = _co.texList;
        _ck(_v, 197, 0, currVal_54);
        var currVal_55 = _co.SuccessMessageIsVisible;
        _ck(_v, 206, 0, currVal_55);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.titulo;
        _ck(_v, 24, 0, currVal_0);
        var currVal_1 = i0.ɵnov(_v, 52).ngClassUntouched;
        var currVal_2 = i0.ɵnov(_v, 52).ngClassTouched;
        var currVal_3 = i0.ɵnov(_v, 52).ngClassPristine;
        var currVal_4 = i0.ɵnov(_v, 52).ngClassDirty;
        var currVal_5 = i0.ɵnov(_v, 52).ngClassValid;
        var currVal_6 = i0.ɵnov(_v, 52).ngClassInvalid;
        var currVal_7 = i0.ɵnov(_v, 52).ngClassPending;
        _ck(_v, 47, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
        var currVal_14 = i0.ɵnov(_v, 93).ngClassUntouched;
        var currVal_15 = i0.ɵnov(_v, 93).ngClassTouched;
        var currVal_16 = i0.ɵnov(_v, 93).ngClassPristine;
        var currVal_17 = i0.ɵnov(_v, 93).ngClassDirty;
        var currVal_18 = i0.ɵnov(_v, 93).ngClassValid;
        var currVal_19 = i0.ɵnov(_v, 93).ngClassInvalid;
        var currVal_20 = i0.ɵnov(_v, 93).ngClassPending;
        _ck(_v, 88, 0, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20);
        var currVal_26 = i0.ɵnov(_v, 125).ngClassUntouched;
        var currVal_27 = i0.ɵnov(_v, 125).ngClassTouched;
        var currVal_28 = i0.ɵnov(_v, 125).ngClassPristine;
        var currVal_29 = i0.ɵnov(_v, 125).ngClassDirty;
        var currVal_30 = i0.ɵnov(_v, 125).ngClassValid;
        var currVal_31 = i0.ɵnov(_v, 125).ngClassInvalid;
        var currVal_32 = i0.ɵnov(_v, 125).ngClassPending;
        _ck(_v, 120, 0, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32);
        var currVal_38 = i0.ɵnov(_v, 156).ngClassUntouched;
        var currVal_39 = i0.ɵnov(_v, 156).ngClassTouched;
        var currVal_40 = i0.ɵnov(_v, 156).ngClassPristine;
        var currVal_41 = i0.ɵnov(_v, 156).ngClassDirty;
        var currVal_42 = i0.ɵnov(_v, 156).ngClassValid;
        var currVal_43 = i0.ɵnov(_v, 156).ngClassInvalid;
        var currVal_44 = i0.ɵnov(_v, 156).ngClassPending;
        _ck(_v, 151, 0, currVal_38, currVal_39, currVal_40, currVal_41, currVal_42, currVal_43, currVal_44);
    });
}
function View_NuevaCausaComponent_15(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 6, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 3, 'div', [['class', 'col-xs-12 col-sm-8  isa_error msg-error']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 0, 'i', [['class', 'fa fa-times-circle']], null, null, null, null, null)), (_l()(), i0.ɵted(null, [' ', '\n            '])), (_l()(), i0.ɵted(null, ['\n        ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.ErrorMsg;
        _ck(_v, 5, 0, currVal_0);
    });
}
function View_NuevaCausaComponent_17(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 5, 'wizard-step', [], null, [[null, 'onNext']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onNext' === en)) {
                var pd_0 = (_co.onStepNewNext($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, i3.View_WizardStepComponent_0, i3.RenderType_WizardStepComponent)), i0.ɵdid(114688, [[10, 4], [7, 4]], 0, i4.WizardStepComponent, [], { title: [0, 'title'], isValid: [1,
                'isValid'], checkBeforeNext: [2, 'checkBeforeNext'] }, { onNext: 'onNext' }), (_l()(),
            i0.ɵted(0, ['\n                    '])), (_l()(), i0.ɵeld(0, null, 0, 1, 'datos-ingreso', [], null, [[null, 'onComplete']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onComplete' === en)) {
                var pd_0 = (_co.onCompleteStepNew($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, i5.View_DatosIngresoComponent_0, i5.RenderType_DatosIngresoComponent)), i0.ɵdid(114688, [[2, 4]], 0, i6.DatosIngresoComponent, [i7.UsuarioService, i8.ExpedienteService, i9.CommonService], { instancia: [0, 'instancia'], cir: [1, 'cir'], fue: [2, 'fue'], tex: [3, 'tex'], ingDirecto: [4,
                'ingDirecto'] }, { onComplete: 'onComplete' }), (_l()(), i0.ɵted(0, ['\n                ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'Ingreso';
        var currVal_1 = _co.isValidStepNew;
        var currVal_2 = true;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2);
        var currVal_3 = _co.instancia;
        var currVal_4 = _co.cir;
        var currVal_5 = _co.fue;
        var currVal_6 = _co.tex_cod;
        var currVal_7 = _co.ingDirecto;
        _ck(_v, 4, 0, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
    }, null);
}
function View_NuevaCausaComponent_20(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.instancia;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_NuevaCausaComponent_19(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 101, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 8, 'div', [['class', 'media']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵeld(0, null, null, 5, 'div', [['class', 'media-body']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                '])),
        (_l()(), i0.ɵeld(0, null, null, 2, 'div', [['class', 'lv-title ng-binding mttde']], null, null, null, null, null)),
        (_l()(), i0.ɵeld(0, null, null, 1, 'strong', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Datos de la Demanda'])), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 11, 'div', [['class', 'media']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵeld(0, null, null, 8, 'div', [['class', 'media-body']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(),
            i0.ɵeld(0, null, null, 1, 'div', [['class', 'lv-title font-datos-exp-ic ng-binding']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['Circunscripción:'])), (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(), i0.ɵeld(0, null, null, 2, 'small', [['class', 'lv-small ng-binding']], null, null, null, null, null)), (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 11, 'div', [['class', 'media']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵeld(0, null, null, 8, 'div', [['class', 'media-body']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(),
            i0.ɵeld(0, null, null, 1, 'div', [['class', 'lv-title font-datos-exp-ic ng-binding']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['Tipo de Expediente:'])), (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(), i0.ɵeld(0, null, null, 2, 'small', [['class', 'lv-small ng-binding']], null, null, null, null, null)), (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 11, 'div', [['class', 'media']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵeld(0, null, null, 8, 'div', [['class', 'media-body']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(),
            i0.ɵeld(0, null, null, 1, 'div', [['class', 'lv-title font-datos-exp-ic ng-binding']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['Instancia:'])), (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(), i0.ɵeld(0, null, null, 2, 'small', [['class', 'lv-small ng-binding']], null, null, null, null, null)), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_NuevaCausaComponent_20)),
        i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 11, 'div', [['class', 'media']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵeld(0, null, null, 8, 'div', [['class', 'media-body']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(),
            i0.ɵeld(0, null, null, 1, 'div', [['class', 'lv-title font-datos-exp-ic ng-binding']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['Fuero:'])), (_l()(), i0.ɵted(null, ['\n                                '])),
        (_l()(), i0.ɵeld(0, null, null, 2, 'small', [['class', 'lv-small ng-binding']], null, null, null, null, null)),
        (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 11, 'div', [['class', 'media']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵeld(0, null, null, 8, 'div', [['class', 'media-body']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(),
            i0.ɵeld(0, null, null, 1, 'div', [['class', 'lv-title font-datos-exp-ic ng-binding']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['Caratula:'])), (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(), i0.ɵeld(0, null, null, 2, 'small', [['class', 'lv-small ng-binding']], null, null, null, null, null)), (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 10, 'div', [['class', 'media']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵeld(0, null, null, 7, 'div', [['class', 'media-body']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(),
            i0.ɵeld(0, null, null, 1, 'div', [['class', 'lv-title font-datos-exp-ic ng-binding']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['Reserva:'])), (_l()(), i0.ɵted(null, ['\n                                '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'small', [['class', 'lv-small ng-binding']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['NO'])), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 11, 'div', [['class', 'media']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵeld(0, null, null, 8, 'div', [['class', 'media-body']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(),
            i0.ɵeld(0, null, null, 1, 'div', [['class', 'lv-title font-datos-exp-ic ng-binding']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['Monto:'])), (_l()(), i0.ɵted(null, ['\n                                '])),
        (_l()(), i0.ɵeld(0, null, null, 2, 'small', [['class', 'lv-small ng-binding']], null, null, null, null, null)),
        (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵted(null, ['\n                    ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = (_co.instancia != 0);
        _ck(_v, 47, 0, currVal_2);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.cir;
        _ck(_v, 21, 0, currVal_0);
        var currVal_1 = _co.tex_cod;
        _ck(_v, 34, 0, currVal_1);
        var currVal_3 = _co.nuevaCausa.concepto.fuero;
        _ck(_v, 60, 0, currVal_3);
        var currVal_4 = _co.nuevaCausa.caratula;
        _ck(_v, 73, 0, currVal_4);
        var currVal_5 = _co.nuevaCausa.monto;
        _ck(_v, 98, 0, currVal_5);
    });
}
function View_NuevaCausaComponent_23(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵted(null, ['\n                                            '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'div', [['class', 'col-xs-12 lv-title font-datos-exp-ic']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ''])), (_l()(), i0.ɵted(null, ['\n                                            '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'div', [['class', 'col-xs-12 lv-small']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ' ', ''])), (_l()(), i0.ɵted(null, ['\n                                    ']))], null, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.tipoVin.cod;
        _ck(_v, 2, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.nombre;
        var currVal_2 = _v.context.$implicit.apellido;
        _ck(_v, 5, 0, currVal_1, currVal_2);
    });
}
function View_NuevaCausaComponent_22(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵeld(0, null, null, 7, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(), i0.ɵeld(0, null, null, 1, 'div', [['class', 'col-xs-12 lv-title font-datos-exp-ic']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ''])), (_l()(), i0.ɵted(null, ['\n                                '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'div', [['class', 'col-xs-12 lv-small']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ' ', ''])), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class', 'row mbpc']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_NuevaCausaComponent_23)), i0.ɵdid(802816, null, 0, i2.NgForOf, [i0.ViewContainerRef, i0.TemplateRef, i0.IterableDiffers], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵted(null, ['\n                        ']))], function (_ck, _v) {
        var currVal_3 = _v.context.$implicit.representantes;
        _ck(_v, 13, 0, currVal_3);
    }, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.tipoVin.cod;
        _ck(_v, 4, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.nombre;
        var currVal_2 = _v.context.$implicit.apellido;
        _ck(_v, 7, 0, currVal_1, currVal_2);
    });
}
function View_NuevaCausaComponent_21(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 14, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 8, 'div', [['class', 'media']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵeld(0, null, null, 5, 'div', [['class', 'media-body']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                '])),
        (_l()(), i0.ɵeld(0, null, null, 2, 'div', [['class', 'lv-title ng-binding mttde']], null, null, null, null, null)),
        (_l()(), i0.ɵeld(0, null, null, 1, 'strong', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Partes de la Causa'])), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_NuevaCausaComponent_22)), i0.ɵdid(802816, null, 0, i2.NgForOf, [i0.ViewContainerRef, i0.TemplateRef, i0.IterableDiffers], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), i0.ɵted(null, ['\n                    ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.nuevaCausa.partes;
        _ck(_v, 13, 0, currVal_0);
    }, null);
}
function View_NuevaCausaComponent_18(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 19, 'div', [['class',
                'col-md-3 line-left-dexp']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class', 'card-header color-titulos-dexp']], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 1, 'h2', [['class', 'h2tituloExp']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Datos del Expediente'])),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 10, 'div', [['class', 'listview']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(),
            i0.ɵeld(0, null, null, 7, 'div', [['class', 'lv-body']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_NuevaCausaComponent_19)), i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_NuevaCausaComponent_21)),
        i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                '])),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵted(null, ['\n        ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isValidStep1;
        _ck(_v, 13, 0, currVal_0);
        var currVal_1 = _co.isValidStep2;
        _ck(_v, 16, 0, currVal_1);
    }, null);
}
function View_NuevaCausaComponent_16(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 49, 'div', [['class',
                'row card']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 37, 'div', [['class', 'col-md-9']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 34, 'form-wizard', [], null, null, null, i10.View_WizardComponent_0, i10.RenderType_WizardComponent)), i0.ɵdid(1163264, [[6, 4]], 1, i11.WizardComponent, [], null, null), i0.ɵqud(603979776, 10, { wizardSteps: 1 }),
        (_l()(), i0.ɵted(0, ['\n                '])), (_l()(), i0.ɵeld(0, null, 0, 5, 'wizard-step', [], null, [[null, 'onCancel'],
            [null, 'onNext']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onCancel' === en)) {
                var pd_0 = (_co.onCancelar($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('onNext' === en)) {
                var pd_1 = (_co.onStep1Next($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, i3.View_WizardStepComponent_0, i3.RenderType_WizardStepComponent)), i0.ɵdid(114688, [[10, 4], [7, 4]], 0, i4.WizardStepComponent, [], { title: [0, 'title'],
            isValid: [1, 'isValid'] }, { onNext: 'onNext', onCancel: 'onCancel' }), (_l()(),
            i0.ɵted(0, ['\n                    '])), (_l()(), i0.ɵeld(0, null, 0, 1, 'datos-demanda', [], null, [[null, 'onComplete']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onComplete' === en)) {
                var pd_0 = (_co.onCompleteStep1($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, i12.View_DatosDemandaComponent_0, i12.RenderType_DatosDemandaComponent)),
        i0.ɵdid(114688, [[1, 4]], 0, i13.DatosDemandaComponent, [i7.UsuarioService, i9.CommonService], { tex_cod: [0, 'tex_cod'], fuero: [1, 'fuero'], tipo: [2, 'tipo'], inst: [3, 'inst'],
            cir: [4, 'cir'], cir_descr: [5, 'cir_descr'], conexo: [6, 'conexo'], organismo: [7,
                'organismo'] }, { onComplete: 'onComplete' }), (_l()(), i0.ɵted(0, ['\n                '])),
        (_l()(), i0.ɵted(0, ['\n                '])), (_l()(), i0.ɵand(16777216, null, 0, 1, null, View_NuevaCausaComponent_17)), i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), i0.ɵted(0, ['\n                '])), (_l()(), i0.ɵeld(0, null, 0, 5, 'wizard-step', [], null, [[null, 'onNext']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onNext' === en)) {
                var pd_0 = (_co.onStep2Next($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, i3.View_WizardStepComponent_0, i3.RenderType_WizardStepComponent)), i0.ɵdid(114688, [[10, 4], [7, 4]], 0, i4.WizardStepComponent, [], { title: [0, 'title'],
            isValid: [1, 'isValid'] }, { onNext: 'onNext' }), (_l()(), i0.ɵted(0, ['\n                    '])),
        (_l()(), i0.ɵeld(0, null, 0, 1, 'partes-causa', [], null, [[null, 'onComplete']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onComplete' === en)) {
                var pd_0 = (_co.onCompleteStep2($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, i14.View_PartesCausaComponent_0, i14.RenderType_PartesCausaComponent)),
        i0.ɵdid(114688, [[3, 4]], 0, i15.PartesCausaComponent, [i7.UsuarioService, i9.CommonService,
            i8.ExpedienteService], { tex_cod: [0, 'tex_cod'] }, { onComplete: 'onComplete' }),
        (_l()(), i0.ɵted(0, ['\n                '])), (_l()(), i0.ɵted(0, ['\n                '])),
        (_l()(), i0.ɵeld(0, null, 0, 5, 'wizard-step', [], null, [[null, 'onNext'], [null, 'onPrev']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onNext' === en)) {
                var pd_0 = (_co.onStep3Next($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('onPrev' === en)) {
                var pd_1 = (_co.onStep3Prev($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, i3.View_WizardStepComponent_0, i3.RenderType_WizardStepComponent)), i0.ɵdid(114688, [[10, 4], [7, 4]], 0, i4.WizardStepComponent, [], { title: [0, 'title'],
            isValid: [1, 'isValid'] }, { onNext: 'onNext', onPrev: 'onPrev' }), (_l()(), i0.ɵted(0, ['\n                    '])), (_l()(), i0.ɵeld(0, null, 0, 1, 'demanda', [], null, [[null, 'onComplete']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onComplete' === en)) {
                var pd_0 = (_co.onCompleteStep3($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, i16.View_DemandaComponent_0, i16.RenderType_DemandaComponent)), i0.ɵdid(114688, [[4, 4]], 0, i17.DemandaComponent, [i7.UsuarioService, i9.CommonService], null, { onComplete: 'onComplete' }), (_l()(), i0.ɵted(0, ['\n                '])), (_l()(),
            i0.ɵted(0, ['\n                '])), (_l()(), i0.ɵeld(0, null, 0, 5, 'wizard-step', [], null, [[null, 'onPrint'], [null, 'onFirma'],
            [null, 'onNew'], [null, 'onPrev']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('onPrint' === en)) {
                var pd_0 = (_co.imprimirReporte($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('onFirma' === en)) {
                var pd_1 = (_co.onFirmaWizard($event) !== false);
                ad = (pd_1 && ad);
            }
            if (('onNew' === en)) {
                var pd_2 = (_co.onCancelar($event) !== false);
                ad = (pd_2 && ad);
            }
            if (('onPrev' === en)) {
                var pd_3 = (_co.onStep4Prev($event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, i3.View_WizardStepComponent_0, i3.RenderType_WizardStepComponent)), i0.ɵdid(114688, [[10, 4], [7, 4]], 0, i4.WizardStepComponent, [], { title: [0, 'title'],
            showAfterComplete: [1, 'showAfterComplete'], firma: [2, 'firma'] }, { onPrev: 'onPrev',
            onPrint: 'onPrint', onNew: 'onNew', onFirma: 'onFirma' }), (_l()(), i0.ɵted(0, ['\n                    '])), (_l()(), i0.ɵeld(0, null, 0, 1, 'ficha', [], null, null, null, i18.View_FichaComponent_0, i18.RenderType_FichaComponent)), i0.ɵdid(114688, [[5, 4]], 0, i19.FichaComponent, [i7.UsuarioService, i9.CommonService], { causa: [0, 'causa'], exp: [1, 'exp'] }, null),
        (_l()(), i0.ɵted(0, ['\n                '])), (_l()(), i0.ɵted(0, ['\n            '])),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['aria-labelledby',
                'myLargeModalLabel'], ['class', 'modal fade bs-example-modal-lg'], ['role',
                'dialog'], ['tabindex', '-1']], [[8, 'id', 0]], null, null, null, null)), (_l()(), i0.ɵted(null, ['\n             '])), (_l()(),
            i0.ɵeld(0, null, null, 1, 'firmar', [], null, [[null, 'onStatusChange'], [null, 'firmadorSelected']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('onStatusChange' === en)) {
                    var pd_0 = (_co.modalEscritoEvent($event) !== false);
                    ad = (pd_0 && ad);
                }
                if (('firmadorSelected' === en)) {
                    var pd_1 = (_co.selFirmador($event) !== false);
                    ad = (pd_1 && ad);
                }
                return ad;
            }, i20.View_FirmarComponent_0, i20.RenderType_FirmarComponent)), i0.ɵdid(180224, [[8, 4]], 0, i21.FirmarComponent, [i8.ExpedienteService, i9.CommonService, i22.DomSanitizer], null, { onStatusChange: 'onStatusChange', firmadorSelected: 'firmadorSelected' }),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_NuevaCausaComponent_18)), i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), i0.ɵted(null, ['\n\n    ']))], function (_ck, _v) {
        var _co = _v.component;
        _ck(_v, 5, 0);
        var currVal_0 = 'Datos';
        var currVal_1 = _co.isValidStep1;
        _ck(_v, 9, 0, currVal_0, currVal_1);
        var currVal_2 = _co.tex_cod;
        var currVal_3 = _co.fue;
        var currVal_4 = _co.tipoIngreso;
        var currVal_5 = _co.instancia;
        var currVal_6 = _co.cir;
        var currVal_7 = _co.cir_desc;
        var currVal_8 = _co.ingConexo;
        var currVal_9 = _co.orgSelected;
        _ck(_v, 12, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9);
        var currVal_10 = _co.ingDirecto;
        _ck(_v, 16, 0, currVal_10);
        var currVal_11 = 'Partes';
        var currVal_12 = _co.isValidStep2;
        _ck(_v, 19, 0, currVal_11, currVal_12);
        var currVal_13 = _co.tex_cod;
        _ck(_v, 22, 0, currVal_13);
        var currVal_14 = 'Demanda';
        var currVal_15 = _co.isValidStep3;
        _ck(_v, 26, 0, currVal_14, currVal_15);
        _ck(_v, 29, 0);
        var currVal_16 = 'Ficha';
        var currVal_17 = true;
        var currVal_18 = true;
        _ck(_v, 33, 0, currVal_16, currVal_17, currVal_18);
        var currVal_19 = _co.nuevaCausa;
        var currVal_20 = _co.nuevoExp;
        _ck(_v, 36, 0, currVal_19, currVal_20);
        var currVal_22 = _co.showPreview;
        _ck(_v, 48, 0, currVal_22);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_21 = ('firmar-' + _co.instanceId);
        _ck(_v, 41, 0, currVal_21);
    });
}
export function View_NuevaCausaComponent_0(_l) {
    return i0.ɵvid(0, [i0.ɵqud(671088640, 1, { datos: 0 }), i0.ɵqud(671088640, 2, { ingreso: 0 }),
        i0.ɵqud(671088640, 3, { partes: 0 }), i0.ɵqud(671088640, 4, { files: 0 }), i0.ɵqud(671088640, 5, { ficha: 0 }), i0.ɵqud(671088640, 6, { wiz: 0 }), i0.ɵqud(671088640, 7, { wizStep: 0 }),
        i0.ɵqud(671088640, 8, { firmar: 0 }), i0.ɵqud(402653184, 9, { msgPopup: 0 }), (_l()(), i0.ɵeld(0, null, null, 22, 'div', [['class', 'container-fluid container-cards-pf container-pf-nav-pf-vertical container-pf-nav-pf-vertical-with-secondary col-xs-12 col-md-10 col-md-push-1 col-md-push-1']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class', 'block-header']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n        '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'h2', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['INGRESO DE CAUSA ', ''])), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(),
            i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_NuevaCausaComponent_1)), i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_NuevaCausaComponent_15)),
        i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(),
            i0.ɵand(16777216, null, null, 1, null, View_NuevaCausaComponent_16)),
        i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(),
            i0.ɵeld(0, null, null, 4, 'div', [], [[8, 'id', 0]], null, null, null, null)), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 1, 'app-message', [], null, null, null, i23.View_Message_0, i23.RenderType_Message)), i0.ɵdid(49152, [[9, 4]], 0, i24.Message, [], { config: [0, 'config'] }, null), (_l()(), i0.ɵted(null, ['\n    '])),
        (_l()(), i0.ɵted(null, ['\n'])), (_l()(), i0.ɵted(null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.selectDatos;
        _ck(_v, 18, 0, currVal_1);
        var currVal_2 = _co.ErrorMessageIsVisible;
        _ck(_v, 21, 0, currVal_2);
        var currVal_3 = _co.cargaDatos;
        _ck(_v, 24, 0, currVal_3);
        var currVal_5 = _co.mensajeConfigSource;
        _ck(_v, 29, 0, currVal_5);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.titulo;
        _ck(_v, 14, 0, currVal_0);
        var currVal_4 = ('msg-popup-' + _co.instanceId);
        _ck(_v, 26, 0, currVal_4);
    });
}
export function View_NuevaCausaComponent_Host_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'nueva-causa', [], null, null, null, View_NuevaCausaComponent_0, RenderType_NuevaCausaComponent)), i0.ɵdid(114688, null, 0, i25.NuevaCausaComponent, [i9.CommonService, i8.ExpedienteService, i9.CommonService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
export var NuevaCausaComponentNgFactory = i0.ɵccf('nueva-causa', i25.NuevaCausaComponent, View_NuevaCausaComponent_Host_0, {}, {}, []);
//# sourceMappingURL=nueva-causa.component.ngfactory.js.map